/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ChangeOrderTemplatesControllerFindAllQueryResponse, ChangeOrderTemplatesControllerFindAllQueryParams, ChangeOrderTemplatesControllerFindAll401, ChangeOrderTemplatesControllerFindAll403 } from "../../models/changeOrderTemplatesController/ChangeOrderTemplatesControllerFindAll";

function getChangeOrderTemplatesControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/change-order-templates` as const }  
  return res
}

/**
 * @summary List a project's change order templates (filter[scopeId] required, filter[kind] optional)
 * {@link /api/v1/change-order-templates}
 */
export async function changeOrderTemplatesControllerFindAll(params?: ChangeOrderTemplatesControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ChangeOrderTemplatesControllerFindAllQueryResponse, ResponseErrorConfig<ChangeOrderTemplatesControllerFindAll401 | ChangeOrderTemplatesControllerFindAll403>, unknown>({ method : "GET", url : getChangeOrderTemplatesControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}